import React from "react";
import { strings } from "../../common/i18n";
import MatReactTableServer from "../../common/components/MaterialReactTableServer";
import useColumnsRows from "./useColumnsRows";
import ArchiveDialog from "./ArchiveDialog";
import AbandonAuditDialog from "./AbandonAuditDialog";
import Auditors from "../Review/components/LeftComponents/Auditors";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import { Button } from "@mui/material/";
import Tabs from "./Tabs";
/**
 * InProgress audit Component
 */

export default () => {
    const {
        columns,
        closeArchiveDialog,
        closeAbandonDialog,
        currentStatus,
        currentRow,
        abandonRow,
        abandonDialog,
        data,
        fetchAudits,
        loading,
        archiveDialog,
        onMultipleArchive,
        onMultipleEmailReminder,
        onMultipleAbandon,
        rowActions,
        tableInitialState,
        persistKey,
        selectionResetToken,
        enableRowSelection,
        getSubRows,
        manageAuditorsRow,
        setManageAuditorsRow,
        page,
        pageSize,
        rowCount,
        setPage,
        setPageSize,
        setSearchQuery,
        setLoading
    } = useColumnsRows();

    const toolBarComponents = (selectedRowData) => (
        <>
            <Button
                size="small"
                variant="text"
                startIcon={<Inventory2OutlinedIcon fontSize="small" />}
                color={selectedRowData?.length ? "primary" : "inherit"}
                disabled={!selectedRowData?.length}
                onClick={() => onMultipleArchive(selectedRowData)}
            >
                {strings("archive")}
            </Button>
            <Button
                size="small"
                variant="text"
                startIcon={<NotificationsNoneOutlinedIcon fontSize="small" />}
                color={
                    selectedRowData?.length &&
                    selectedRowData.every((r) => r.actions?.reminderEmail)
                        ? "primary"
                        : "inherit"
                }
                disabled={
                    !selectedRowData?.length ||
                    !selectedRowData.every((r) => r.actions?.reminderEmail)
                }
                onClick={() => onMultipleEmailReminder(selectedRowData)}
            >
                {strings("sendReminder")}
            </Button>
            <Button
                size="small"
                variant="text"
                startIcon={<BlockOutlinedIcon fontSize="small" />}
                color={
                    selectedRowData?.length &&
                    selectedRowData.every((r) => r.actions?.abandonAudit)
                        ? "primary"
                        : "inherit"
                }
                disabled={
                    !selectedRowData?.length ||
                    !selectedRowData.every((r) => r.actions?.abandonAudit)
                }
                onClick={() => onMultipleAbandon(selectedRowData)}
            >
                {strings("abandonAudit")}
            </Button>
        </>
    );

    return (
        <>
            <Tabs />
            <MatReactTableServer
                columns={columns}
                data={data}
                loading={loading}
                rowActions={rowActions}
                rowSelection={true}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noInprogressAudits")}
                page={page}
                pageSize={pageSize}
                rowCount={rowCount}
                setPage={setPage}
                setPageSize={setPageSize}
                setSearchQuery={setSearchQuery}
                initialState={tableInitialState}
                persistKey={persistKey}
                selectionResetToken={selectionResetToken}
                enableRowSelection={enableRowSelection}
                muiCheckboxProps={({ row }) => ({
                    sx: { display: row.original.isGroup ? "none" : "inline-flex" }
                })}
                getSubRows={getSubRows}
            />
            <ArchiveDialog
                open={archiveDialog}
                onClose={closeArchiveDialog}
                row={currentRow}
                currentStatus={currentStatus}
                setLoading={setLoading}
                fetchAudits={fetchAudits}
            />
            <AbandonAuditDialog
                open={abandonDialog}
                onClose={closeAbandonDialog}
                row={abandonRow}
                setLoading={setLoading}
                fetchAudits={fetchAudits}
            />
            {manageAuditorsRow && (
                <Auditors
                    open={true}
                    auditId={manageAuditorsRow.id}
                    onClose={() => setManageAuditorsRow(null)}
                    onSaveComplete={fetchAudits}
                />
            )}
        </>
    );
};

/*
onRowClick was intentionally omitted — audits rows are not clickable for all orgs.
*/
